import { t } from 'i18next';

import AppleBadge from '../images/apple-badge.png';
import GoogleBadge from '../images/google-badge.png';

export const PromoSection = ({ promo }: { promo?: boolean }) => {
  return (
    <div
      className={['mb-3 text-center w-100', promo ? 'bg-success card card-body' : undefined]
        .filter((p) => p)
        .join(' ')
        .trim()}
    >
      {promo && <h2 className='h6'>{t('stripe.promo-message')}</h2>}
      <div>
        <a
          href='https://apps.apple.com/se/app/the-enzo-way/id1603056676'
          target='_blank'
          rel='noreferrer'
          className='p-1'
        >
          <img
            src={AppleBadge}
            alt='App Store badge'
            className={['rounded-3', promo ? undefined : 'border']
              .filter((p) => p)
              .join(' ')
              .trim()}
          />
        </a>
        <a
          href='https://play.google.com/store/apps/details?id=se.enzogroup.enzoapp'
          target='_blank'
          rel='noreferrer'
          className='p-1'
        >
          <img
            src={GoogleBadge}
            alt='Google Play Store badge'
            className={['rounded-3', promo ? undefined : 'border']
              .filter((p) => p)
              .join(' ')
              .trim()}
          />
        </a>
      </div>
    </div>
  );
};
